var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'app-login': _vm.isLoginPage },attrs:{"id":"app"}},[_c('div',{staticClass:"app-stage-shell",style:(_vm.stageShellStyle)},[_c('div',{staticClass:"app-stage"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }